export interface PublicNavItem {
  key: string;
  label: string;
  href: string;
}

export const publicNav: PublicNavItem[] = [
  { key: 'pn-home', label: 'Home', href: '/' },
  { key: 'pn-about', label: 'About', href: '/about' },
  { key: 'pn-memberships', label: 'Memberships', href: '/memberships' },
  { key: 'pn-contact', label: 'Contact', href: '/contact' },
];

export interface MembershipPlan {
  key: string;
  name: string;
  subtitle: string;
  badge: string;
  price: string;
  period: string;
  standardPrice: string;
  tagline: string;
  featured: boolean;
  features: string[];
  smallPrint?: string;
  buttonLabel: string;
  paymentUrl: string;
}

const introCourse = {
  title: 'Is a Care Business Right for You?',
  headline: 'Before You Start a Care Business, Understand What It Really Takes.',
  price: '£49',
  buttonLabel: 'Start Your Journey – £49',
  paymentUrl: 'https://buy.stripe.com/14A3cuexdfSX5EA80UbEA05',
  summary:
    'This £49 standalone course helps aspiring care business owners understand the responsibilities, risks, financial commitments and personal readiness involved, before they commit time and money.',
  covers: [
    'The responsibilities of running a regulated care business',
    'The risks you need to understand up front',
    'The financial commitment involved',
    'Your personal readiness to lead',
  ],
};

export interface CgsCategory {
  key: string;
  title: string;
  items: string[];
}

const cgsCategories: CgsCategory[] = [
  {
    key: 'cgs-reg17',
    title: 'Regulation 17 & Quality Assurance',
    items: [
      'Regulation 17 monitoring',
      'CQC mock tests',
      'Audits and compliance reviews',
      'Actions and evidence tracking',
      'Themes and trends monitoring',
      'Care quality monitoring',
    ],
  },
  {
    key: 'cgs-safeguarding',
    title: 'Safeguarding & Risk',
    items: [
      'Safeguarding records',
      'Incident reporting',
      'Near-miss monitoring',
      'Missed visits monitoring',
      'Complaints logs',
      'Risk and action monitoring',
    ],
  },
  {
    key: 'cgs-workforce',
    title: 'Workforce & HR',
    items: [
      'Recruitment pipeline',
      'HR monitoring',
      'Staff spot checks',
      'Training monitoring',
      'Competency assessments',
    ],
  },
  {
    key: 'cgs-operational',
    title: 'Operational Governance',
    items: [
      'Policy library',
      'Business continuity planning',
      'Emergency planning',
      'Health and safety monitoring',
      'EDI monitoring',
      'Subject Access Request logs',
    ],
  },
];

export { cgsCategories };
export { introCourse };